<template>
  <div class="ticket-view">
    <li class="id-view">衣单单号：{{ticket.idView}}</li>
    <li class="create-at">创建时间：{{ticket.createAt | dt}}</li>
    <li class="plan-take-off">计划取衣：{{ticket.planTakeAwayAt | dt}}</li>
    <li class="real-take-off">取走时间：{{ticket.realTakeAwayAt | dt}}</li>
    <li class="clothe-count">衣服件数：{{ticket.clotheRecords===undefined ? '' : ticket.clotheRecords.length}}</li>
    
    <div class="clothes">
      <ticket-clothes :items="ticket.clotheRecords" mode="view"></ticket-clothes>
    </div>
  </div>
</template>

<script>
import TicketClothes from '@/components/list/TicketClothes'

export default {
  props: ['ticket'],
  components: {
    TicketClothes
  }
}
</script>

<style scoped>
li {
  list-style: none;
}
.ticket-view {
  border: #cccccc solid 1px;
  border-radius: 4px;
  padding: 10px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Ticket.vue